import BaseFieldsDrawerController from "./BaseFieldsDrawerController"
import messageResource from "../../messageResource"
import PasswordFieldsDrawer from "./PasswordFieldsDrawer"
import UserNameDrawer from "./UserNameDrawer"
import PasswordPolicyManager from '../../util/passwords/PasswordPolicyManager'
import $ from 'jquery'
import PasswordHintLink from '../../util/passwords/PasswordHintLink'
import PasswordErrorMessage from '../../util/passwords/PasswordErrorMessage'

function DownloadableAccountFieldsUserPopupDrawer(){}

DownloadableAccountFieldsUserPopupDrawer.prototype = new BaseFieldsDrawerController();

DownloadableAccountFieldsUserPopupDrawer.prototype.init =function(config){
    BaseFieldsDrawerController.prototype.init.call(this, config);
    this.passwordDrawer = new PasswordFieldsDrawer().init(config);
    this.userNameDrawer = new UserNameDrawer().init(config);
    this.addDrawer(this.passwordDrawer);
    this.addDrawer(this.userNameDrawer);
    let $passwordHintContainer = $(config.getElementByIdFunction("passwordRequirementsTip"));
    $passwordHintContainer.empty();
    this.passwordHint = new PasswordHintLink({
        passwordPolicy: PasswordPolicyManager,
        my: "right top", left: 10,
        $hintContainer: $(config.lightBoxEl)
    }).init($passwordHintContainer)
    return this;
};

DownloadableAccountFieldsUserPopupDrawer.prototype.getNotCopyValues = function(){
  return {passwordData : this.passwordDrawer.getPlainPasswordValues(), username: this.userNameDrawer.getObjectValues().username}
};

DownloadableAccountFieldsUserPopupDrawer.prototype.getNewPassword = function(){
  return  this.passwordDrawer.getNewPassword();
};

/*Create Drawer*/
export function DownloadableAccountFieldsCreateUserPopupDrawer(){}

DownloadableAccountFieldsCreateUserPopupDrawer.prototype = new DownloadableAccountFieldsUserPopupDrawer();

DownloadableAccountFieldsCreateUserPopupDrawer.prototype.init = function(config){
    DownloadableAccountFieldsUserPopupDrawer.prototype.init.call(this, config);
    this.passwordFieldsError = new PasswordErrorMessage({additionalClass: "inlineErrorMessage"}).init($(config.getElementByIdFunction("errorsContainer")))
    return this;
}

DownloadableAccountFieldsCreateUserPopupDrawer.prototype.initFields = function(config){
    this.passwordDrawer.setPasswordsAreMandatory(true);
    BaseFieldsDrawerController.prototype.initFields.call(this, config.accountSettings);
    this.passwordDrawer.setPasswordFieldsPlaceholders(
            messageResource.getMessage("user.add.js.password_field.placeholder"),
            messageResource.getMessage("user.add.js.password_copy_field.placeholder")
        )
}

DownloadableAccountFieldsCreateUserPopupDrawer.prototype.setErrorState = function(errors, passwordValidationResult) {
    this.passwordFieldsError.setState({passwordValidationResult})
}

/* Edit drawer */
export function DownloadableAccountFieldsEditUserPopupDrawer(){}

DownloadableAccountFieldsEditUserPopupDrawer.prototype = new DownloadableAccountFieldsUserPopupDrawer();

DownloadableAccountFieldsEditUserPopupDrawer.prototype.initFields = function(config) {
    this.passwordDrawer.setPasswordsAreMandatory(false)
    BaseFieldsDrawerController.prototype.initFields.call(this, config.accountSettings)
    if (!(this.passwordDrawer.getPlainPasswordValues().password || this.passwordDrawer.getPlainPasswordValues().passwordCopy))
        this.passwordDrawer.setPasswordFieldsPlaceholders(
            messageResource.getMessage("user.edit.js.password_field.placeholder"),
            messageResource.getMessage("user.edit.js.password_copy_field.placeholder")
        )
}




// WEBPACK FOOTER //
// ./web/js/administration/userManagement/DownloadableAccountFieldsUserPopupDrawer.js